<div class="cc-checkout">
  <div id="payment-element"></div>
  <!-- display errors -->
  <p class="card-errors">{{ cardErrors }}</p>
</div>
